module.exports = __webpack_public_path__ + "img/file_txt.13e000ab.svg";